:host {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(4 * var(--spacer));
}

.day {
  display: table;
  height: calc(3 * var(--spacer));
  width: calc(3 * var(--spacer));
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0;
  padding: 0;
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size);
  position: relative;
  border-radius: 50%;
  border: none;
  outline-offset: 0;
  .currentDayMarker {
    display: table-cell;
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}

.day:not(.disabled) {
  cursor: pointer;
  &:hover {
    background: var(--datepicker-cell-hovered);
  }
  &:focus-visible {
    background: transparent;
    outline: 1px solid var(--datepicker-cell-focused-border);
  }
  &:active {
    background: var(--datepicker-cell-pressed);
  }
}

.day.hovered {
  color: var(--datepicker-cell-hovered-text, white);
  position: relative;
}

.day.selected {
  background: var(--datepicker-cell-selected) !important;
  color: var(--datepicker-cell-selected-text, white);
  position: relative;
}

.day.currentDate .currentDayMarker {
  color: var(--blue-layout-400-primary);
}

.day.currentDate.selected .currentDayMarker {
  color: var(--datepicker-cell-selected-text);
}

.day.disabled {
  color: var(--grey-layout-200-disabled);
}
